export interface PaysafeAccounts {
  default: number;
}
